module.exports = __webpack_public_path__ + "media/images/earn-icon-44164fd04106056ecf50d10bc3295f2b.svg";